import React from 'react';
import PropTypes from 'prop-types';
import { useUiV2 } from '../../config/uiVersion';
import LoginShellV2 from '../PublicV2/LoginShellV2';
import './Login.css';

// Shared IronSight brandmark: the corner bracket + offset square from
// public/logo.svg, measured from the top-left symbol of the official wordmark.
// Painted in the brand gray directly on the shapes, which reads on both the
// dark hero panel and the light form panel. Intrinsic width and height are set
// for the reason logo.svg documents — with only a viewBox the mark renders
// screen-filling if the stylesheet has not landed yet.
export function Mark({ className }) {
    return (
        <svg className={className} width="30" height="30" viewBox="0 0 64 64" fill="none" aria-hidden="true">
            {/* Official IronSight corner bracket (L-mark from the wordmark's
                top-left), geometry measured 1:1 from Branding/IronSight.png. */}
            <path d="M8 14H56V29H26V50H8Z" fill="#788080" />
        </svg>
    );
}
Mark.propTypes = { className: PropTypes.string };

// Two-column auth layout: the hunter-green brand panel the app wears in its
// header, plus a right-hand form card on the shared surface tokens.
function LoginShellV1({ children }) {
    return (
        <div className="lg">
            <aside className="lg-hero">
                <div className="lg-hero-brand"><Mark className="lg-hero-mark" /><span className="lg-hero-word">IronSight</span></div>
                <div className="lg-hero-main">
                    <span className="lg-hero-eyebrow">Predictive inventory intelligence</span>
                    <h1 className="lg-hero-h1">Price it right.<br />Sell it faster.</h1>
                    <p className="lg-hero-p">An AI-predicted price, a days-to-sell forecast and live carrying-cost margin on every unit in your yard.</p>
                </div>
                <div className="lg-hero-stats">
                    <div className="lg-hero-stat"><b>Every unit</b><span>scored overnight</span></div>
                    <div className="lg-hero-stat"><b>10+ signals</b><span>fused per unit</span></div>
                    <div className="lg-hero-stat"><b>One verdict</b><span>ranked, ready to act</span></div>
                </div>
            </aside>
            <main className="lg-panel">
                <div className="lg-card">
                    <div className="lg-brand"><Mark className="lg-brand-mark" /><span className="lg-brand-word">IronSight</span></div>
                    {children}
                </div>
            </main>
        </div>
    );
}
LoginShellV1.propTypes = { children: PropTypes.node };

// The sign-in steps (WorkspaceLogin, TenantLogin) keep their logic and markup;
// only the frame around them follows the "new design" flag, which on these
// logged-out routes comes from ?ui=v2 or localStorage (config/uiVersion.js).
export default function LoginShell({ children }) {
    const uiV2 = useUiV2();
    return uiV2 ? <LoginShellV2>{children}</LoginShellV2> : <LoginShellV1>{children}</LoginShellV1>;
}
LoginShell.propTypes = { children: PropTypes.node };
